import styled from '@emotion/styled';
import { Container, Typography } from '@mui/material';

export const UnitsContainer = styled(Container)`
  display: flex;
  margin-top: 5%;
  margin-bottom: 10%;
  position: relative;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Title = styled(Typography)`
  color: black;
  margin-bottom: 5%;
`;
